import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api } from "../../lib/api";
import { LoadingState } from "../states";
import { RatingStars } from "../RatingStars";
import { ReviewList } from "../ReviewList";

export function KitchenRatings({ chefSlug }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/kitchen/ratings").then(({ data }) => setData(data)).catch(() => setData({ chef_reviews: [], recipes: [] })); }, []);
  if (!data) return <LoadingState label="Loading ratings…" />;
  return (
    <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-6 items-start" data-testid="kitchen-ratings">
      <div className="rounded-3xl bg-white border border-border shadow-soft p-6">
        <p className="text-xs font-bold uppercase tracking-widest text-coral">Your chef rating</p>
        <div className="mt-2 flex items-center gap-3">
          <span className="font-heading text-5xl font-black text-ink" data-testid="kitchen-chef-rating">{data.chef_rating_avg || "—"}</span>
          <div><RatingStars value={data.chef_rating_avg || 0} size={18} /><p className="text-sm text-ink-soft font-semibold">{data.chef_rating_count} {data.chef_rating_count === 1 ? "rating" : "ratings"} from members</p></div>
        </div>
        <h3 className="font-heading text-lg font-black text-ink mt-6 mb-3">Recent chef reviews</h3>
        <ReviewList reviews={data.chef_reviews} emptyText="No one has rated your profile yet." />
      </div>
      <div>
        <h3 className="font-heading text-lg font-black text-ink mb-3">Recipe ratings</h3>
        {data.recipes.length === 0 ? <p className="text-ink-soft text-sm">Publish recipes to start collecting ratings.</p> : (
          <div className="space-y-3">
            {data.recipes.map((r) => (
              <div key={r.id} className="rounded-2xl bg-white border border-border p-4" data-testid={`kitchen-rating-${r.slug}`}>
                <div className="flex items-center gap-3">
                  <img src={r.thumbnail} alt="" className="w-12 h-12 rounded-xl object-cover border border-border" />
                  <div className="flex-1 min-w-0">
                    <Link to={`/chefs/${chefSlug}/${r.slug}`} className="font-heading font-black text-ink hover:text-coral truncate block">{r.title}</Link>
                    <p className="text-xs text-ink-soft font-semibold inline-flex items-center gap-1"><Star size={12} className="fill-gold text-gold" /> {r.rating_avg} · {Number(r.rating_count || 0).toLocaleString()} ratings</p>
                  </div>
                </div>
                {r.reviews?.length > 0 && <div className="mt-3"><ReviewList reviews={r.reviews} /></div>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
